import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import Typography from '@mui/material/Typography'
import LightModeIcon from '@mui/icons-material/LightMode'
const OpenWeighing = ({ id, response, condition_, isWeighingComplete }) => {
  const [condition, setCondition] = useState(null)

  useEffect(() => {
    console.log(condition_)
    setCondition(condition_)
  }, [condition_])

  const conditionBt = () => {
    if (condition && condition === 'Взвешивание') {
      return (
        <>
          <Typography variant="h6" gutterBottom>
            <b>Открытие взвешивания</b>
          </Typography>
          <Typography variant="body1" gutterBottom>
            Вес рыбы должен быть внесен во всех секторах перед закрытием
            взвешивания.
          </Typography>
          <Button
            variant="outlined"
            disabled={isWeighingComplete}
            onClick={() => response(2)}
            color="secondary"
            fullWidth
            startIcon={<DoDisturbIcon />}
          >
            Закрыть взвешивание
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Typography variant="h6" gutterBottom>
            <b>Открытие взвешивания</b>
          </Typography>
          <Typography variant="body1" gutterBottom>
            Откройте взвешивание всех секторов. Для дополнительного взвешивания
            одной команды предусмотрен отдельный раздел
          </Typography>
          <Button
            variant="outlined"
            onClick={() => response(1)}
            fullWidth
            style={{ marginTop: '10px' }}
          >
            Открыть взвешивание
          </Button>
        </>
      )
    }
  }

  return conditionBt()
}

export default OpenWeighing
